module.exports = __webpack_public_path__ + "img/feature3-2.35ef2a67.png";